export default __webpack_public_path__ + "static/media/faq.6481192c.svg";